<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>
    
    <form class = "card-form"  [formGroup]="motorFormContinued" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
        <div class="blue-top"></div>
        <div class="card-section top-section" *ngIf="newUser">
            <h1><b>{{pageHeading}}</b></h1>
            <h2>{{personalDetails}}</h2>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{genderLabel}}
                </mat-label>
                <mat-select formControlName="gender"  panelClass="form-select-popup" (blur)="logErrors()">
                    <mat-option class="form-option" [value]="genderOption" *ngFor="let genderOption of GenderOptions">
                        {{genderOption}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['gender']">{{formErrors['gender']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{'Email Address'}}</mat-label>
                <input matInput formControlName="email" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['email']">{{formErrors['email']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{dobLabel}}</mat-label>
                <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="dobPicker" (blur)="logErrors()" readonly="true" (click)="dobPicker.open()" formControlName="dob">
                <mat-error *ngIf="formErrors['dob']">{{formErrors['dob']}}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                <mat-datepicker #dobPicker >
                </mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{idTypeLabel}}
                </mat-label>
                <mat-select formControlName="idType"  panelClass="form-select-popup" (blur)="logErrors()" (selectionChange)="updateID()">
                    <mat-option class="form-option" [value]="idTypePlaceHolders" *ngFor="let idTypePlaceHolders of IdTypePlaceHolders">
                        {{idTypePlaceHolders}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['idType']">{{formErrors['idType']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" *ngIf="selectedIdType && selectedIdType.length > 2">
                <mat-label class="form-select-placeholder-unselected" >{{idNumLabel}}</mat-label>
                <input matInput maxlength={{maxIDNUMLength}} spellcheck="false" formControlName="idNum" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['idNum']">{{formErrors['idNum']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{kraNumLabel}}</mat-label>
                <input matInput type="text" maxlength="11" spellcheck="false" formControlName="kraNum" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['kraNum']">{{formErrors['kraNum']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select last-item" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{coverStartDateLabel}}</mat-label>
                <mat-hint>{{coveStartDateDesc}}</mat-hint>
                <input matInput  [min]="minCoverDate" [max]="maxCoverDate" (blur)="logErrors()" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="coverStartDate">
                <mat-error *ngIf="formErrors['coverStartDate']">{{formErrors['coverStartDate']}}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker >
                </mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{agentCodeLabel}}</mat-label>
                <input matInput formControlName="agentCode" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['agentCode']">{{formErrors['agentCode']}}</mat-error>
            </mat-form-field>

        </div>

        <div class="card-section bottom-section">
            
            <h1  *ngIf="newUser === false"><b>{{pageHeading}}</b></h1>
            <h2>{{vehicleDetails}}</h2>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{vehicleChassisNumberLabel}}</mat-label>
                <input matInput formControlName="vehicleChassisNumber" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['vehicleChassisNumber']">{{formErrors['vehicleChassisNumber']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{vehicleEngineNumberLabel}}</mat-label>
                <input matInput formControlName="vehicleEngineNumber" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['vehicleEngineNumber']">{{formErrors['vehicleEngineNumber']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-hint *ngIf="!motorFormContinued.controls['vehicleColor'].value" >
                    {{colourHint}}
                </mat-hint>
                <mat-label class="form-select-placeholder-unselected">
                    {{vehicleColorLabel}}
                </mat-label>
                <input matInput formControlName="vehicleColor" [matAutocomplete]="auto"  (blur)="logErrors()">
                
                <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayValue" >
                    <mat-option class="form-option" *ngFor="let color of filteredColors | async" [value]="color">
                        {{color}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" *ngIf="insurance === 'private'">
                <mat-label class="form-select-placeholder-unselected">
                    {{vehicleCapacityLabel}}
                </mat-label>
                <input maxlength="1" matInput spellcheck="false" formControlName="vehicleSeatingCapacity" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['vehicleSeatingCapacity']">{{formErrors['vehicleSeatingCapacity']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{vehicleRatingLabel}}</mat-label>
                <input matInput maxlength="4" spellcheck="false" formControlName="vehicleRating" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['vehicleRating']">{{formErrors['vehicleRating']}}</mat-error>
            </mat-form-field>

              <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected">
                    {{vehicleBodyTypeLabel}}
                </mat-label>
                <mat-select formControlName="vehicleBodyType"  panelClass="form-select-popup" (blur)="logErrors()" [disabled]="bodyDisabled">
                    <mat-option class="form-option" [value]="vehicleBodyTypePlaceHolders" *ngFor="let vehicleBodyTypePlaceHolders of VehicleBodyTypePlaceHolders">
                        {{vehicleBodyTypePlaceHolders}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="formErrors['vehicleBodyType']">{{formErrors['vehicleBodyType']}}</mat-error>
            </mat-form-field>

            <div class="row-div margin-top-50" *ngIf="newUser">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorFormContinued.valid">
                    <span class="button-text" >{{saveContinue}}</span>
                </button>
            </div>

        </div>

        <div class="card-section bottom-section" *ngIf="!newUser">
            <mat-form-field appearance="outline" class="form-select last-item" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{coverStartDateLabel}}</mat-label>
                <mat-hint>{{coveStartDateDesc}}</mat-hint>
                <input matInput  [min]="minCoverDate" [max]="maxCoverDate" (blur)="logErrors()" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="coverStartDate">
                <mat-error *ngIf="formErrors['coverStartDate']">{{formErrors['coverStartDate']}}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker >
                </mat-datepicker>
            </mat-form-field>

            <div class="row-div">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorFormContinued.valid">
                    <span class="button-text" >{{saveContinue}}</span>
                </button>
            </div>
        </div>
    </form>
</div>
